<template>
  <rpm-modal
    header="Atualizar Serviço"
    class="flex flex-col gap-y-8"
    persist
    :open="open"
    @close="$emit('close')"
  >
    <section class="flex flex-col gap-6">
      <rpm-input
        required
        label="Nome"
        v-model="form.name"
        :errors="errors.name"
        placeholder="Nome do serviço"
      ></rpm-input>

      <section class="grid grid-cols-4">
        <rpm-input
          type="switch"
          class="items-center"
          v-model="form.visible_web"
          :errors="errors.visible_web"
          label="Portal"
        ></rpm-input>

        <rpm-input
          type="switch"
          class="items-center"
          v-model="form.visible_admin"
          :errors="errors.visible_admin"
          label="Atendimento"
        ></rpm-input>

        <rpm-input
          type="switch"
          class="items-center"
          v-model="form.visible_mobile"
          :errors="errors.visible_mobile"
          label="Aplicativo"
        ></rpm-input>
        <rpm-input
          type="switch"
          class="items-center"
          v-model="form.enabled"
          :errors="errors.enabled"
          label="Habilitado"
        ></rpm-input>
        <rpm-input
          type="switch"
          class="items-center mt-4"
          v-model="form.address_required"
          :errors="errors.address_required"
          label="Necessita endereço"
        ></rpm-input>
        <rpm-input
          type="switch"
          class="items-center mt-4"
          v-model="form.internal_service"
          :errors="errors.internal_service"
          label="Serviço interno"
        ></rpm-input>
      </section>

      <section class="grid grid-cols-1 gap-6">
      <rpm-input
        required
        type="select"
        v-model="form.visibility"
        :errors="errors.visibility"
        label="Visibilidade"
        :options="sourceServiceVisibilities"
        optionValue="id"
        optionLabel="description"
      ></rpm-input>
      </section>

      <section class="grid md:grid-cols-3 grid-cols-1 gap-6">
        <rpm-input
          required
          type="select"
          v-model="form.source_service_category.id"
          :errors="errors.source_service_category.id"
          label="Categoria"
          :options="sourceServiceCategories"
          optionValue="id"
          optionLabel="name"
        ></rpm-input>

        <rpm-input
          required
          type="select"
          v-model="form.source_service_type.id"
          :errors="errors.source_service_type.id"
          label="Tipo"
          :options="sourceServiceTypes"
          optionValue="id"
          optionLabel="name"
        ></rpm-input>

        <rpm-input
          optional
          type="select"
          v-model="form.source_service_priority.id"
          :errors="errors.source_service_priority.id"
          label="Prioridade"
          :options="sourceServicePriorities"
          optionValue="id"
          optionLabel="name"
        ></rpm-input>


      </section>

      <rpm-input
        type="editor"
        required
        v-model="form.description"
        :errors="errors.description"
        label="Descrição"
      ></rpm-input>
    </section>

    <section class="flex flex-row justify-center gap-6">
      <rpm-button
        color="gray"
        label="Cancelar"
        @click="$emit('close')"
      ></rpm-button>

      <rpm-button
        label="Confirmar"
        :loading="loading"
        @click="$emit('submit')"
      ></rpm-button>
    </section>
  </rpm-modal>
</template>


<script>

import RpmModal from "#components/RpmModal.vue";

import sourceServiceRepository from "#repositories/sourceServiceRepository";
import sourceServiceTypeRepository from "#repositories/sourceServiceTypeRepository";
import sourceServicePriorityRepository from "#repositories/sourceServicePriorityRepository";
import sourceServiceCategoryRepository from "#repositories/sourceServiceCategoryRepository";
import RoleRepository from "#repositories/roleRepository";
import _ from 'lodash'

export default {
  name: "CreateSourceServiceModal",
  components: {
    RpmModal
  },
  data() {
    return {
      sourceServiceVisibilities: [],
      sourceServiceTypes: [],
      sourceServicePriorities: [],
      sourceServiceCategories: [],
      roles: []
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: {
        source_service_category: {},
        source_service_type: {},
        source_service_priority: {},
        address_required: false,
        roles: []
      }
    },
    errors: {
      type: Object,
      default: {
        source_service_category: {},
        source_service_type: {},
        source_service_priority: {}
      }
    }
  },
  async mounted(){
    this.sourceServiceVisibilities = (await sourceServiceRepository.fetchVisibilityTypes());
    this.sourceServiceTypes = (await sourceServiceTypeRepository.getSourceServiceTypes()).data;
    this.sourceServicePriorities = (await sourceServicePriorityRepository.getSourceServicePriorities()).data;
    this.sourceServiceCategories = (await sourceServiceCategoryRepository.getSourceServiceCategories()).data;
    this.roles = (await RoleRepository.getRoles()).data;
  }
};
</script>
